import type { PropertiesPanelSelectionSummary } from './types/properties-panel-selection-summary'

export function describePropertiesPanelSelection({
  activeItem,
  objectCount,
  textBoxCount,
}: PropertiesPanelSelectionSummary): string {
  if (activeItem === 'type') return 'Click or drag on the canvas to place text'
  if (activeItem === 'shape') return 'Choose a shape, then draw on the canvas'
  if (activeItem === 'document') return 'Document-wide settings'
  if (activeItem === 'spellcheck') return 'Check spelling on this spread'

  const total = objectCount + textBoxCount

  if (total === 0) return 'No Selection'
  if (total > 1) return `${total} Objects Selected`

  return objectCount === 1 ? '1 Object Selected' : '1 Text Box Selected'
}
